import { useState } from "react";
import { useGetIdentity, useNotify } from "ra-core";
import { useQueryClient } from "@tanstack/react-query";
import { Button } from "@/components/ui/button";
import { TagCreateModal } from "./TagCreateModal";
import type { Tag } from "../types";
export function CreateTagButton({
  onCreated,
}: {
  onCreated?: (tag: Tag) => Promise<void> | void;
}) {
  const { identity } = useGetIdentity();
  const [open, setOpen] = useState(false);
  const queryClient = useQueryClient();
  const notify = useNotify();
  if (!identity?.administrator) return null;
  return (
    <>
      <Button
        type="button"
        variant="outline"
        size="sm"
        className="min-h-9"
        onClick={() => setOpen(true)}
      >
        Создать тег
      </Button>
      <TagCreateModal
        open={open}
        onClose={() => setOpen(false)}
        onSuccess={async (tag) => {
          await queryClient.invalidateQueries({ queryKey: ["tags"] });
          await onCreated?.(tag);
          notify("Тег добавлен", { type: "success" });
        }}
      />
    </>
  );
}
